import { Component, type ErrorInfo, type ReactNode } from "react";

export class ErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(JSON.stringify({ level: "error", error: error.message, info: info.componentStack }));
  }

  render() {
    if (this.state.error) return this.props.fallback;
    return this.props.children;
  }
}
